@if (!print) {
    <app-page-header subtitle="Verkeersmaatregelen">
        <div class="status" filters>
            @if (form?.value?.paid) {
                <div>Afgerekend</div>
            }
        </div>
        <div print-pdf>
            @if (Features.VkmExcelExport | hasFeature) {
                <button class="menu-button" (click)="excel()" color="primary" mat-icon-button>
                    <mat-icon fontSet="fa-regular" fontIcon="fa-file-excel"></mat-icon>
                </button>
            }
            <button class="menu-button" (click)="pdf()" color="primary" mat-icon-button>
                @if (!downloadingPdf) {
                    <mat-icon fontSet="fa-regular" fontIcon="fa-file-pdf"></mat-icon>
                }
                @if (downloadingPdf) {
                    <mat-spinner></mat-spinner>
                }
            </button>
            <button class="menu-button" [disabled]="printing" (click)="printThis()" color="primary" mat-icon-button>
                @if (!printing) {
                    <mat-icon fontSet="fa-regular" fontIcon="fa-print"></mat-icon>
                }
                @if (printing) {
                    <mat-spinner></mat-spinner>
                }
            </button>
        </div>
    </app-page-header>
}
@if (form && infoBar) {
    <div class="info-bar">
        <div class="container-xl">
            <div class="col">
                <div class="row pt-2 pb-2">
                    @if (form.controls.planning_vkm.value) {
                        <div class="col">
                            {{
                                form.controls.planning_vkm.controls[
                                    currentTabIndex - ((Functionalities.VkmManagement | hasFunctionality) ? 1 : 0)
                                ] | nameTabs: form.controls.planning_vkm.controls
                            }}
                            -
                            {{
                                form.getRawValue().planning_vkm[
                                    currentTabIndex - ((Functionalities.VkmManagement | hasFunctionality) ? 1 : 0)
                                ]?.begindate | date: 'EEEE d MMMM'
                            }}
                        </div>
                    }
                    <div class="col text-right">
                        {{ form.getRawValue().afas_project_id }} {{ form.getRawValue().contractor ? '-' : '' }}
                        {{ form.getRawValue().contractor }} {{ form.getRawValue().location ? '-' : '' }}
                        {{ form.getRawValue().location }}
                    </div>
                </div>
            </div>
        </div>
    </div>
}
@if (form && entitiesMap) {
    <div class="container-xl vkm-edit">
        <div>
            @if (!print) {
                <div class="row">
                    <div class="col-md-12 col-lg-6">
                        <ng-select
                            class="ng-select-fill project-selection"
                            [formControl]="form.controls.afas_project_id"
                            [typeahead]="searchAfasProjects$"
                            [clearable]="true"
                            [selectableGroup]="false"
                            [items]="projects"
                            placeholder="Project"
                            groupBy="mainProject"
                            bindLabel="name"
                            bindValue="afas_project_id">
                            <ng-template ng-label-tmp let-item="item">
                                <b>{{ item.afas_project_id }}</b> {{ item.name }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <b>{{ item.afas_project_id }}</b> {{ item.name }}
                            </ng-template>
                        </ng-select>
                    </div>
                    @if (form.getRawValue().afas_project_id) {
                        <div class="col-md-12 col-lg-6">
                            <mat-form-field class="w-100" appearance="fill">
                                <mat-label>Beschrijving</mat-label>
                                <input
                                    [formControl]="form.controls.description"
                                    matInput
                                    placeholder="Beschrijving"
                                    type="text" />
                                <mat-error [control]="form.controls.description"></mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <mat-form-field class="w-100" appearance="fill">
                                <mat-label>Opdrachtgever</mat-label>
                                <input
                                    [matAutocomplete]="autoContractors"
                                    [formControl]="form.controls.contractor"
                                    matInput
                                    placeholder="Opdrachtgever"
                                    type="text" />
                                <mat-autocomplete #autoContractors="matAutocomplete" autoActiveFirstOption>
                                    @for (val of autocompleteContractors; track val) {
                                        <mat-option [value]="val">
                                            {{ val }}
                                        </mat-option>
                                    }
                                </mat-autocomplete>
                                <mat-error [control]="form.get('contractor')"></mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <app-location-select
                                [control]="form.controls.location"
                                source="VkmPlanningComponent.location">
                            </app-location-select>
                        </div>
                    }
                </div>
            }
        </div>
        @if (form.getRawValue().afas_project_id) {
            <div class="d-flex" [class.pb-5]="!print" [class.mb-5]="!print">
                <mat-tab-group
                    class="vkm-mat-tab-group"
                    [(selectedIndex)]="currentTabIndex"
                    (selectedTabChange)="tabChanged($event)"
                    animationDuration="0"
                    mat-stretch-tabs="false">
                    @if (Functionalities.VkmManagement | hasFunctionality) {
                        <mat-tab [matMenuTriggerFor]="menu" labelClass="add-tab">
                            <ng-template matTabLabel>
                                <div
                                    class="curpoint add-btn"
                                    [matMenuTriggerFor]="menu"
                                    (click)="$event.stopPropagation()"
                                    matRipple>
                                    <i class="fal fa-plus-circle"></i>
                                </div>
                            </ng-template>
                        </mat-tab>
                    }
                    @for (
                        planning of form.controls.planning_vkm.controls
                            | sortTabs: form.controls.planning_vkm.value?.length ?? 0;
                        track planning;
                        let i = $index
                    ) {
                        <mat-tab #tab>
                            <ng-template matTabLabel>
                                <div class="tab">
                                    <div class="tab-name">
                                        {{
                                            planning
                                                | nameTabs
                                                    : form.controls.planning_vkm.controls
                                                    : form.value.planning_vkm?.length
                                        }}
                                    </div>
                                    <small>
                                        {{
                                            planning.controls.begindate.value
                                                ? (planning.controls.begindate.value | date: 'EE d MMM yyyy')
                                                : '-'
                                        }}
                                    </small>
                                </div>
                            </ng-template>
                            <ng-template matTabContent>
                                <div class="col mt-3">
                                    @if (!print) {
                                        <div class="row">
                                            <div class="col">
                                                <div class="d-flex justify-content-between mb-2">
                                                    <h2>Gegevens</h2>
                                                    @if ((Functionalities.VkmManagement | hasFunctionality) && !print) {
                                                        <button
                                                            (click)="removeWorkorder(planning)"
                                                            mat-raised-button
                                                            color="warn">
                                                            <i class="fas fa-trash"></i> Verwijder deze
                                                            {{ planning.controls.type.value }}
                                                        </button>
                                                    }
                                                </div>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <mat-form-field class="date w-100" appearance="fill">
                                                            <mat-label>Datum</mat-label>
                                                            <input
                                                                [matDatepicker]="pickerStart"
                                                                [formControl]="planning.controls.date.controls.date"
                                                                (focus)="pickerStart.open()"
                                                                matInput
                                                                placeholder="Datum"
                                                                tabindex="-1" />
                                                            <div class="d-flex" matSuffix>
                                                                <mat-datepicker-toggle
                                                                    [for]="pickerStart"></mat-datepicker-toggle>
                                                                @if (planning.controls.date.enabled) {
                                                                    <button
                                                                        (click)="
                                                                            $event.stopPropagation();
                                                                            resetDates(planning)
                                                                        "
                                                                        mat-icon-button>
                                                                        <mat-icon class="fa-solid fa-xmark"></mat-icon>
                                                                    </button>
                                                                }
                                                            </div>
                                                            <mat-datepicker #pickerStart></mat-datepicker>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-6">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>Van</mat-label>
                                                            <mat-select
                                                                [formControl]="
                                                                    planning.controls.date.controls.begintime
                                                                "
                                                                placeholder="van"
                                                                panelWidth="190px">
                                                                @if (startTimes) {
                                                                    @for (
                                                                        date of startTimes.get(planning);
                                                                        track date
                                                                    ) {
                                                                        <mat-optgroup
                                                                            label="{{
                                                                                date.datetime | date: 'EEEE d MMM'
                                                                            }}">
                                                                            @for (time of date.options; track time) {
                                                                                <mat-option
                                                                                    [disabled]="time.notAvailable"
                                                                                    [value]="time.time">
                                                                                    {{ time.datetime | date: 'HH:mm' }}
                                                                                    uur
                                                                                </mat-option>
                                                                            }
                                                                        </mat-optgroup>
                                                                    }
                                                                }
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col-6">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>Tot</mat-label>
                                                            <mat-select
                                                                [formControl]="planning.controls.date.controls.endtime"
                                                                placeholder="Tot tijd"
                                                                panelWidth="190px">
                                                                @if (endTimes) {
                                                                    @for (day of endTimes.get(planning); track day) {
                                                                        <mat-optgroup
                                                                            label="{{
                                                                                day.datetime | date: 'EEEE d MMM'
                                                                            }}">
                                                                            @for (time of day.options; track time) {
                                                                                <mat-option
                                                                                    [disabled]="time.notAvailable"
                                                                                    [value]="time.time">
                                                                                    {{ time.datetime | date: 'HH:mm' }}
                                                                                    uur
                                                                                </mat-option>
                                                                            }
                                                                        </mat-optgroup>
                                                                    }
                                                                }
                                                            </mat-select>
                                                            <mat-error
                                                                [control]="planning.controls.date.controls.endtime">
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>{{
                                                                environment.executorName | ucFirst
                                                            }}</mat-label>
                                                            <mat-select
                                                                [formControl]="planning.controls.performer_id"
                                                                [placeholder]="environment.executorName | ucFirst">
                                                                @for (executor of executors; track executor) {
                                                                    <mat-option [value]="executor.id">{{
                                                                        executor.name
                                                                    }}</mat-option>
                                                                }
                                                            </mat-select>
                                                            @if (planning.controls.performer_id.value) {
                                                                <mat-hint>
                                                                    Telefoon:
                                                                    {{
                                                                        usersMap.get(
                                                                            planning.controls.performer_id.value
                                                                        )?.phone
                                                                    }}
                                                                </mat-hint>
                                                            }
                                                            <mat-error [control]="form.get('performer')"></mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        @for (
                                                            mechanicFg of planning.controls.mechanics.controls;
                                                            track mechanicFg
                                                        ) {
                                                            <div class="row">
                                                                <div class="col">
                                                                    <div class="mat-ng-select">
                                                                        <ng-select
                                                                            class="ng-select-fill"
                                                                            [formControl]="
                                                                                mechanicFg.controls.mechanic_id
                                                                            "
                                                                            [clearable]="true"
                                                                            placeholder="Eerste monteur">
                                                                            @for (
                                                                                mechanic of mechanics;
                                                                                track mechanic
                                                                            ) {
                                                                                <ng-option [value]="mechanic.id">{{
                                                                                    mechanic.name
                                                                                }}</ng-option>
                                                                            }
                                                                        </ng-select>
                                                                        @if (mechanicFg.controls.mechanic_id.value) {
                                                                            <mat-hint>
                                                                                Telefoon:
                                                                                {{
                                                                                    usersMap.get(
                                                                                        mechanicFg.controls.mechanic_id
                                                                                            .value
                                                                                    )?.phone
                                                                                }}
                                                                            </mat-hint>
                                                                        }
                                                                        <mat-error
                                                                            [control]="
                                                                                mechanicFg.controls.mechanic_id
                                                                            "></mat-error>
                                                                    </div>
                                                                </div>
                                                                <div class="col">
                                                                    <div class="mat-ng-select">
                                                                        <ng-select
                                                                            class="ng-select-fill"
                                                                            [formControl]="
                                                                                mechanicFg.controls.sec_mechanic_id
                                                                            "
                                                                            [clearable]="true"
                                                                            placeholder="Tweede monteur">
                                                                            @for (
                                                                                mechanic of mechanics;
                                                                                track mechanic
                                                                            ) {
                                                                                <ng-option [value]="mechanic.id">{{
                                                                                    mechanic.name
                                                                                }}</ng-option>
                                                                            }
                                                                        </ng-select>
                                                                        @if (
                                                                            mechanicFg.controls.sec_mechanic_id.value
                                                                        ) {
                                                                            <mat-hint>
                                                                                Telefoon:
                                                                                {{
                                                                                    usersMap.get(
                                                                                        mechanicFg.controls
                                                                                            .sec_mechanic_id.value
                                                                                    )?.phone
                                                                                }}
                                                                            </mat-hint>
                                                                        }
                                                                        <mat-error
                                                                            [control]="
                                                                                mechanicFg.controls.sec_mechanic_id
                                                                            "></mat-error>
                                                                    </div>
                                                                </div>
                                                                @if (
                                                                    (Functionalities.VkmManagement
                                                                        | hasFunctionality) &&
                                                                    planning.controls.mechanics.enabled
                                                                ) {
                                                                    <div class="col-auto">
                                                                        <button
                                                                            [class.invisible]="$first"
                                                                            [disabled]="$first"
                                                                            (click)="
                                                                                removeVkmMechanic(
                                                                                    planning.controls.mechanics,
                                                                                    mechanicFg
                                                                                )
                                                                            "
                                                                            color="warn"
                                                                            mat-icon-button
                                                                            tabindex="-1">
                                                                            <mat-icon
                                                                                fontSet="fa"
                                                                                fontIcon="fa-trash"></mat-icon>
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                        @if (Functionalities.VkmManagement | hasFunctionality) {
                                                            <button
                                                                class="w-100 mb-3"
                                                                (click)="addVkmMechanic()"
                                                                mat-stroked-button
                                                                color="primary">
                                                                Monteur toevoegen +
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>Tekeningnr en type vkm</mat-label>
                                                            <input
                                                                [formControl]="planning.controls.drawing"
                                                                type="text"
                                                                matInput
                                                                placeholder="Tekeningnr en type vkm" />
                                                            <mat-error
                                                                [control]="planning.controls.drawing"></mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                    <div class="col">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>V&G-plan</mat-label>
                                                            <input
                                                                [formControl]="planning.controls.vg_plan"
                                                                type="text"
                                                                matInput
                                                                placeholder="V&G-plan" />
                                                            <mat-error
                                                                [control]="planning.controls.vg_plan"></mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <mat-form-field class="w-100" appearance="fill">
                                                            <mat-label>Omschrijving</mat-label>
                                                            <textarea
                                                                [formControl]="planning.controls.comment"
                                                                matInput
                                                                placeholder="Omschrijving"
                                                                rows="4"></textarea>
                                                            <mat-error
                                                                [control]="planning.controls.comment"></mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col">
                                                <h2>Voorbereiding en uitvoering</h2>
                                                <table
                                                    class="table table-center table-add-row table-last-col"
                                                    [class.table-last-col]="
                                                        (Functionalities.VkmManagement | hasFunctionality) && !print
                                                    "
                                                    [class.table-add-row]="
                                                        (Functionalities.VkmManagement | hasFunctionality) && !print
                                                    ">
                                                    <tr>
                                                        <th>Materieelobject</th>
                                                        <th>Aantal</th>
                                                        <th></th>
                                                        @if (
                                                            (Functionalities.VkmManagement | hasFunctionality) && !print
                                                        ) {
                                                            <th></th>
                                                        }
                                                    </tr>
                                                    @for (
                                                        workline of planning.controls.workorderMaterials.controls;
                                                        track workline
                                                    ) {
                                                        <tr [formGroup]="workline">
                                                            <td class="select driver">
                                                                <ng-select
                                                                    [formControl]="workline.controls.entity_id"
                                                                    [clearable]="false"
                                                                    placeholder="Materieel"
                                                                    appendTo="body">
                                                                    @for (m of preparation; track m) {
                                                                        <ng-option
                                                                            [value]="m.id"
                                                                            [innerHTML]="m.name"></ng-option>
                                                                    }
                                                                </ng-select>
                                                            </td>
                                                            <td class="number-input">
                                                                @if (
                                                                    entitiesMap.get(workline.controls.entity_id.value)
                                                                        ?.unit === 'uur'
                                                                ) {
                                                                    <input
                                                                        [decimalInput]="2"
                                                                        [formControl]="workline.controls.count_placed"
                                                                        appDecimalInput
                                                                        autocomplete="off"
                                                                        matInput
                                                                        placeholder="0"
                                                                        type="text" />
                                                                }
                                                                @if (
                                                                    entitiesMap.get(workline.controls.entity_id.value)
                                                                        ?.unit !== 'uur'
                                                                ) {
                                                                    <input
                                                                        [decimalInput]="0"
                                                                        [formControl]="workline.controls.count_placed"
                                                                        appDecimalInput
                                                                        autocomplete="off"
                                                                        matInput
                                                                        placeholder="0"
                                                                        type="text" />
                                                                }
                                                            </td>
                                                            <td>
                                                                {{
                                                                    entitiesMap.get(workline.controls.entity_id.value)
                                                                        ?.unit
                                                                }}
                                                            </td>
                                                            @if (
                                                                (Functionalities.VkmManagement | hasFunctionality) &&
                                                                !print
                                                            ) {
                                                                <td class="p-0">
                                                                    <button
                                                                        class="delete-button"
                                                                        (click)="
                                                                            removeWorkorderLine(
                                                                                planning.controls.workorderMaterials,
                                                                                workline
                                                                            )
                                                                        "
                                                                        color="warn"
                                                                        mat-icon-button
                                                                        tabindex="-1">
                                                                        <mat-icon
                                                                            fontSet="fa"
                                                                            fontIcon="fa-trash"></mat-icon>
                                                                    </button>
                                                                </td>
                                                            }
                                                        </tr>
                                                    }
                                                    @if ((Functionalities.VkmManagement | hasFunctionality) && !print) {
                                                        <tr>
                                                            <td [colSpan]="3">
                                                                <div class="d-flex">
                                                                    <button
                                                                        class="w-100"
                                                                        (click)="
                                                                            addWorkoderLine(
                                                                                planning,
                                                                                planning.controls.workorderMaterials
                                                                            )
                                                                        "
                                                                        color="primary"
                                                                        mat-button>
                                                                        Toevoegen <i class="fas fa-plus"></i>
                                                                    </button>
                                                                    <button
                                                                        class="w-100"
                                                                        (click)="
                                                                            removeEmptyLines(
                                                                                planning.controls.workorderMaterials
                                                                            )
                                                                        "
                                                                        color="primary"
                                                                        mat-button>
                                                                        Lege regels verwijderen
                                                                        <i class="fas fa-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    }
                                    @if (!print) {
                                        <div class="row mb-3">
                                            <div class="col">
                                                <button
                                                    class="me-2"
                                                    (click)="checklist('controlepunten', planning.controls.id.value)"
                                                    mat-raised-button
                                                    color="primary">
                                                    Controlepunten
                                                    <i
                                                        class="fa-regular {{
                                                            answeredChecklistMap.get('controlepunten')
                                                                ? 'fa-square-check'
                                                                : 'fa-square'
                                                        }}"></i>
                                                </button>
                                                <button
                                                    (click)="checklist('werkoverdracht', planning.controls.id.value)"
                                                    mat-raised-button
                                                    color="primary">
                                                    Werkoverdracht
                                                    <i
                                                        class="fa-regular {{
                                                            answeredChecklistMap.get('werkoverdracht')
                                                                ? 'fa-square-check'
                                                                : 'fa-square'
                                                        }}"></i>
                                                </button>
                                                @if (Functionalities.VkmManagement | hasFunctionality) {
                                                    <button
                                                        class="ms-2"
                                                        (click)="checklistOverview()"
                                                        mat-raised-button
                                                        color="primary">
                                                        Resultaten
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div>
                                        @if (!print) {
                                            <div>
                                                <h2>Materieelobject en aantallen</h2>
                                                <div
                                                    class="curpoint"
                                                    (click)="
                                                        setCountTo(
                                                            'Grondpot',
                                                            planning.controls._ground_pot.value,
                                                            planning
                                                        )
                                                    ">
                                                    Aantal grondpotten:
                                                    <b>{{ planning.controls._ground_pot.value | number: '0.0-0' }}</b>
                                                </div>
                                                <div
                                                    class="curpoint"
                                                    (click)="
                                                        setCountTo(
                                                            'Koppelklem',
                                                            planning.controls._coupling_clamps.value,
                                                            planning
                                                        )
                                                    ">
                                                    Aantal koppelklemmen:
                                                    <b>{{
                                                        planning.controls._coupling_clamps.value | number: '0.0-0'
                                                    }}</b>
                                                </div>
                                            </div>
                                        }
                                        @if (print) {
                                            <div class="d-flex mb-3">
                                                <div>
                                                    <b
                                                        ><u
                                                            >Werkopdracht
                                                            {{
                                                                planning.controls.type.value === 'MWO'
                                                                    ? 'monteren'
                                                                    : 'demonteren'
                                                            }}
                                                            {{ form.controls.afas_project_id.value }}
                                                            {{
                                                                planning
                                                                    | nameTabs
                                                                        : form.controls.planning_vkm.controls
                                                                        : form.value.planning_vkm?.length
                                                            }}</u
                                                        ></b
                                                    >
                                                    <div class="mt-3">
                                                        <table>
                                                            <tr>
                                                                <th style="width: 210px">Datum</th>
                                                                <td>
                                                                    {{
                                                                        planning.controls.date.controls.date.value
                                                                            | date: 'dd-MM-yyyy'
                                                                    }}
                                                                    {{
                                                                        planning.controls.date.controls.begintime.value
                                                                            | date: 'HH:mm'
                                                                    }}
                                                                    tot
                                                                    {{
                                                                        planning.controls.date.controls.endtime.value
                                                                            | date: 'HH:mm'
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Projectnummer</th>
                                                                <td>
                                                                    {{ form.controls.afas_project_id.value }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Locatie</th>
                                                                <td>
                                                                    {{ form.controls.location.value }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Opdrachtgever</th>
                                                                <td>
                                                                    {{ form.controls.contractor.value }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>
                                                                    {{ environment.executorName | ucFirst }}
                                                                </th>
                                                                <td>
                                                                    {{
                                                                        usersMap.get(
                                                                            planning.controls.performer_id.value
                                                                        )?.name
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Tekeningnr en type vkm</th>
                                                                <td>
                                                                    {{ planning.controls.drawing.value }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>V&G-plan</th>
                                                                <td>
                                                                    {{ planning.controls.vg_plan.value }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th style="vertical-align: baseline">Werkzaamheden</th>
                                                                <td
                                                                    [innerHTML]="
                                                                        planning.controls.comment.value | nl2br
                                                                    "></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-end flex-fill">
                                                    <img src="/assets/clean-logo.svg" height="125" />
                                                </div>
                                            </div>
                                        }
                                        @if (planning.value) {
                                            <table
                                                class="table table-center"
                                                [class.table-last-col]="
                                                    (Functionalities.VkmManagement | hasFunctionality) && !print
                                                "
                                                [class.table-add-row]="
                                                    (Functionalities.VkmManagement | hasFunctionality) && !print
                                                ">
                                                <tr>
                                                    <th>Materieelobject</th>
                                                    @if (
                                                        fieldsByType.get(planning.controls.type.value).has('planned')
                                                    ) {
                                                        <th class="px-0">
                                                            {{
                                                                fieldNameByType
                                                                    .get(planning.controls.type.value)
                                                                    .get('planned')
                                                            }}
                                                        </th>
                                                    }
                                                    @if (planning.controls.type.value === 'DWO') {
                                                        <th
                                                            class="curpoint"
                                                            (click)="
                                                                notSettledAll(
                                                                    planning.controls.workorderObjects,
                                                                    fieldsByType
                                                                        .get(planning.controls.type.value)
                                                                        .get('count')
                                                                )
                                                            "
                                                            style="width: 115px">
                                                            {{
                                                                fieldNameByType
                                                                    .get(planning.controls.type.value)
                                                                    .get('count')
                                                            }}
                                                            @if (
                                                                Functionalities.VkmWorkorderExecution | hasFunctionality
                                                            ) {
                                                                <i
                                                                    class="curpoint fa-duotone fa-solid fa-calculator-simple"></i>
                                                            }
                                                        </th>
                                                    }
                                                    @if (planning.controls.type.value === 'MWO') {
                                                        <th
                                                            class="curpoint"
                                                            (click)="
                                                                setPlannedAll(
                                                                    planning.controls.workorderObjects,
                                                                    fieldsByType
                                                                        .get(planning.controls.type.value)
                                                                        .get('count')
                                                                )
                                                            "
                                                            style="width: 115px">
                                                            {{
                                                                fieldNameByType
                                                                    .get(planning.controls.type.value)
                                                                    .get('count')
                                                            }}
                                                            @if (
                                                                Functionalities.VkmWorkorderExecution | hasFunctionality
                                                            ) {
                                                                <i class="fa-duotone fa-solid fa-calculator-simple"></i>
                                                            }
                                                        </th>
                                                    }
                                                    <th
                                                        class="curpoint"
                                                        (click)="
                                                            setDates(
                                                                planning,
                                                                fieldsByType
                                                                    .get(planning.controls.type.value)
                                                                    .get('date')
                                                            )
                                                        "
                                                        style="width: 185px">
                                                        {{
                                                            fieldNameByType
                                                                .get(planning.controls.type.value)
                                                                .get('date')
                                                        }}
                                                        @if (Functionalities.VkmWorkorderExecution | hasFunctionality) {
                                                            <i class="fa-duotone fa-solid fa-calendar-days"></i>
                                                        }
                                                    </th>
                                                    @if (fieldsByType.get(planning.controls.type.value).has('lost')) {
                                                        <th>
                                                            {{
                                                                fieldNameByType
                                                                    .get(planning.controls.type.value)
                                                                    .get('lost')
                                                            }}
                                                        </th>
                                                    }
                                                    <th>Toelichting</th>
                                                    <th style="width: 50px">CROW</th>
                                                    @if ((Functionalities.VkmManagement | hasFunctionality) && !print) {
                                                        <th></th>
                                                    }
                                                </tr>
                                                @for (
                                                    workline of planning.controls.workorderObjects.controls;
                                                    track workline
                                                ) {
                                                    <tr [formGroup]="workline">
                                                        @if (workline.controls.comment.value !== 'text') {
                                                            <td class="select driver">
                                                                <ng-select
                                                                    [formControl]="workline.controls.entity_id"
                                                                    [clearable]="false"
                                                                    (keydown.arrowDown)="
                                                                        $event.stopImmediatePropagation()
                                                                    "
                                                                    placeholder="Materieel"
                                                                    appendTo="body">
                                                                    @for (m of materiaal; track m) {
                                                                        <ng-option
                                                                            [value]="m.id"
                                                                            [innerHTML]="m.name"></ng-option>
                                                                    }
                                                                </ng-select>
                                                            </td>
                                                            @if (
                                                                fieldsByType
                                                                    .get(planning.controls.type.value)
                                                                    .has('planned')
                                                            ) {
                                                                <td class="number-input">
                                                                    <input
                                                                        class="row-input"
                                                                        [formControlName]="
                                                                            fieldsByType
                                                                                .get(planning.controls.type.value)
                                                                                .get('planned')
                                                                        "
                                                                        appDecimalInput
                                                                        autocomplete="off"
                                                                        placeholder="0"
                                                                        type="text" />
                                                                </td>
                                                            }
                                                            <td class="number-input">
                                                                <div class="d-flex align-items-center">
                                                                    <input
                                                                        class="row-input"
                                                                        [formControlName]="
                                                                            fieldsByType
                                                                                .get(planning.controls.type.value)
                                                                                .get('count')
                                                                        "
                                                                        appDecimalInput
                                                                        autocomplete="off"
                                                                        placeholder="0"
                                                                        type="text" />
                                                                    @if (
                                                                        Functionalities.VkmWorkorderExecution
                                                                            | hasFunctionality
                                                                    ) {
                                                                        @if (planning.controls.type.value === 'DWO') {
                                                                            <i
                                                                                class="fa-duotone fa-solid fa-calculator-simple curpoint"
                                                                                [class.disabled]="
                                                                                    !(
                                                                                        form.controls.planning_vkm
                                                                                        | notSettledCount
                                                                                            : workline
                                                                                            : fieldsByType
                                                                                                  .get(
                                                                                                      planning.controls
                                                                                                          .type.value
                                                                                                  )
                                                                                                  .get('count')
                                                                                            : false
                                                                                            : workline.get(
                                                                                                  fieldsByType
                                                                                                      .get(
                                                                                                          planning
                                                                                                              .controls
                                                                                                              .type
                                                                                                              .value
                                                                                                      )
                                                                                                      .get('lost')
                                                                                              ).value
                                                                                            : workline.get(
                                                                                                  fieldsByType
                                                                                                      .get(
                                                                                                          planning
                                                                                                              .controls
                                                                                                              .type
                                                                                                              .value
                                                                                                      )
                                                                                                      .get('count')
                                                                                              ).value
                                                                                    )
                                                                                "
                                                                                (click)="
                                                                                    calcNotSettled(
                                                                                        workline,
                                                                                        fieldsByType
                                                                                            .get(
                                                                                                planning.controls.type
                                                                                                    .value
                                                                                            )
                                                                                            .get('count')
                                                                                    )
                                                                                "></i>
                                                                        }
                                                                        @if (planning.controls.type.value === 'MWO') {
                                                                            <i
                                                                                class="fa-duotone fa-solid fa-calculator-simple curpoint"
                                                                                [class.disabled]="
                                                                                    workline.controls.count_planned
                                                                                        .value < 1
                                                                                "
                                                                                (click)="
                                                                                    setPlanned(
                                                                                        workline,
                                                                                        fieldsByType
                                                                                            .get(
                                                                                                planning.controls.type
                                                                                                    .value
                                                                                            )
                                                                                            .get('count')
                                                                                    )
                                                                                "></i>
                                                                        }
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="d-flex align-items-center">
                                                                    <input
                                                                        class="row-input"
                                                                        [matDatepicker]="pickerStart"
                                                                        [formControlName]="
                                                                            fieldsByType
                                                                                .get(planning.controls.type.value)
                                                                                .get('date')
                                                                        "
                                                                        (focus)="pickerStart.open()"
                                                                        (click)="pickerStart.open()"
                                                                        placeholder="Datum" />
                                                                    <mat-datepicker #pickerStart></mat-datepicker>
                                                                    @if (
                                                                        Functionalities.VkmWorkorderExecution
                                                                            | hasFunctionality
                                                                    ) {
                                                                        <i
                                                                            class="curpoint fa-duotone fa-solid fa-calendar-days"
                                                                            (click)="
                                                                                setDate(
                                                                                    planning,
                                                                                    workline,
                                                                                    fieldsByType
                                                                                        .get(
                                                                                            planning.controls.type.value
                                                                                        )
                                                                                        .get('date')
                                                                                )
                                                                            "></i>
                                                                    }
                                                                </div>
                                                            </td>
                                                            @if (
                                                                fieldsByType
                                                                    .get(planning.controls.type.value)
                                                                    .has('lost')
                                                            ) {
                                                                <td class="number-input">
                                                                    <div class="d-flex align-items-center">
                                                                        <input
                                                                            class="row-input"
                                                                            [formControlName]="
                                                                                fieldsByType
                                                                                    .get(planning.controls.type.value)
                                                                                    .get('lost')
                                                                            "
                                                                            appDecimalInput
                                                                            autocomplete="off"
                                                                            placeholder="0"
                                                                            type="text" />
                                                                        @if (
                                                                            Functionalities.VkmWorkorderExecution
                                                                                | hasFunctionality
                                                                        ) {
                                                                            @if (
                                                                                planning.controls.type.value === 'DWO'
                                                                            ) {
                                                                                <i
                                                                                    class="fa-duotone fa-solid fa-calculator-simple"
                                                                                    [class.disabled]="
                                                                                        !(
                                                                                            form.controls.planning_vkm
                                                                                            | notSettledCount
                                                                                                : workline
                                                                                                : fieldsByType
                                                                                                      .get(
                                                                                                          planning
                                                                                                              .controls
                                                                                                              .type
                                                                                                              .value
                                                                                                      )
                                                                                                      .get('lost')
                                                                                                : false
                                                                                                : workline.get(
                                                                                                      fieldsByType
                                                                                                          .get(
                                                                                                              planning
                                                                                                                  .controls
                                                                                                                  .type
                                                                                                                  .value
                                                                                                          )
                                                                                                          .get('lost')
                                                                                                  ).value
                                                                                                : workline.get(
                                                                                                      fieldsByType
                                                                                                          .get(
                                                                                                              planning
                                                                                                                  .controls
                                                                                                                  .type
                                                                                                                  .value
                                                                                                          )
                                                                                                          .get('count')
                                                                                                  ).value
                                                                                        )
                                                                                    "
                                                                                    (click)="
                                                                                        calcNotSettled(
                                                                                            workline,
                                                                                            fieldsByType
                                                                                                .get(
                                                                                                    planning.controls
                                                                                                        .type.value
                                                                                                )
                                                                                                .get('lost')
                                                                                        )
                                                                                    "></i>
                                                                            }
                                                                        }
                                                                    </div>
                                                                </td>
                                                            }
                                                            <td class="text-input">
                                                                <textarea
                                                                    class="row-input"
                                                                    [formControl]="workline.controls.comment"
                                                                    rows="1"
                                                                    cdkTextareaAutosize
                                                                    placeholder="Opmerking"></textarea>
                                                            </td>
                                                            <td
                                                                class="p-0 curpoint"
                                                                (click)="
                                                                    workline.controls.checked_at.setValue(
                                                                        workline.controls.checked_at.value
                                                                            ? null
                                                                            : planning.controls.begindate.value
                                                                    );
                                                                    workline.controls.checked_at.markAsDirty()
                                                                ">
                                                                <mat-checkbox
                                                                    [formControl]="workline.controls.checked_at"
                                                                    (click)="$event.preventDefault()"
                                                                    style="pointer-events: none"></mat-checkbox>
                                                            </td>
                                                            @if (
                                                                (Functionalities.VkmManagement | hasFunctionality) &&
                                                                !print
                                                            ) {
                                                                <td class="p-0">
                                                                    <button
                                                                        class="delete-button"
                                                                        (click)="
                                                                            removeWorkorderLine(
                                                                                planning.controls.workorderObjects,
                                                                                workline
                                                                            )
                                                                        "
                                                                        color="warn"
                                                                        mat-icon-button
                                                                        tabindex="-1">
                                                                        <mat-icon
                                                                            fontSet="fa"
                                                                            fontIcon="fa-trash"></mat-icon>
                                                                    </button>
                                                                </td>
                                                            }
                                                        }
                                                        @if (workline.controls.comment.value === 'text') {
                                                            <td class="text-input" colspan="6">
                                                                <textarea
                                                                    [formControl]="workline.controls.description"
                                                                    rows="1"
                                                                    cdkTextareaAutosize
                                                                    matInput
                                                                    placeholder="Opmerking"></textarea>
                                                            </td>
                                                            @if (
                                                                (Functionalities.VkmManagement | hasFunctionality) &&
                                                                !print
                                                            ) {
                                                                <td class="p-0">
                                                                    <button
                                                                        class="delete-button"
                                                                        (click)="
                                                                            removeWorkorderLine(
                                                                                planning.controls.workorderObjects,
                                                                                workline
                                                                            )
                                                                        "
                                                                        color="warn"
                                                                        mat-icon-button
                                                                        tabindex="-1">
                                                                        <mat-icon
                                                                            fontSet="fa"
                                                                            fontIcon="fa-trash"></mat-icon>
                                                                    </button>
                                                                </td>
                                                            }
                                                        }
                                                    </tr>
                                                }
                                                @if ((Functionalities.VkmManagement | hasFunctionality) && !print) {
                                                    <tr>
                                                        <td
                                                            [colSpan]="
                                                                3 + fieldsByType.get(planning.controls.type.value).size
                                                            ">
                                                            <div class="d-flex">
                                                                <button
                                                                    class="w-100"
                                                                    (click)="
                                                                        addWorkoderLine(
                                                                            planning,
                                                                            planning.controls.workorderObjects
                                                                        )
                                                                    "
                                                                    color="primary"
                                                                    mat-button>
                                                                    Toevoegen object <i class="fas fa-plus"></i>
                                                                </button>
                                                                <button
                                                                    class="w-100"
                                                                    (click)="
                                                                        addWorkoderLineText(
                                                                            planning.controls.workorderObjects
                                                                        )
                                                                    "
                                                                    color="primary"
                                                                    mat-button>
                                                                    Toevoegen beschrijving <i class="fas fa-plus"></i>
                                                                </button>
                                                                <button
                                                                    class="w-100"
                                                                    (click)="
                                                                        removeEmptyLines(
                                                                            planning.controls.workorderObjects
                                                                        )
                                                                    "
                                                                    color="primary"
                                                                    mat-button>
                                                                    Lege regels verwijderen <i class="fas fa-trash"></i>
                                                                </button>
                                                                <button
                                                                    class="w-100"
                                                                    (click)="addAllMissingObjects(planning)"
                                                                    color="primary"
                                                                    mat-button>
                                                                    Alle regels toevoegen
                                                                    <i class="fa-solid fa-list"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </table>
                                        }
                                        @if (print && vkmQuestions && checklistAnswers?.length) {
                                            <div class="col-24 mt-3">
                                                @for (type of ['controlepunten', 'werkoverdracht']; track type) {
                                                    <h4 class="mt-2 mb-1 text-capitalize">{{ type }}</h4>
                                                    @for (question of vkmQuestions[type]; track question) {
                                                        <div>
                                                            <div class="mb-1">
                                                                @if (question.order) {
                                                                    <span>{{ question.order }}. </span>
                                                                }
                                                                {{ question.question }}
                                                                @if (question.icon) {
                                                                    <span
                                                                        ><img
                                                                            [src]="
                                                                                '/assets/images/vkm-icons/' +
                                                                                question.icon
                                                                            "
                                                                            height="18"
                                                                            alt="icoon"
                                                                    /></span>
                                                                }
                                                                <span class="ms-2 font-weight-bold">{{
                                                                    checklistAnswers
                                                                        | vkmAnswer: type : question.id || '-'
                                                                }}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                    @if (checklistAnswers | vkmAnswer: type : null : true) {
                                                        <div>
                                                            <b>Opmerking:</b>
                                                            {{ checklistAnswers | vkmAnswer: type : null : true }}
                                                        </div>
                                                    }
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </ng-template>
                        </mat-tab>
                    }
                    @if (Functionalities.VkmReadWithPrice | hasFunctionality) {
                        <mat-tab labelClass="calculation" label="Afrekenstaat">
                            <div class="col mt-3">
                                @if (!print && (Functionalities.VkmManagement | hasFunctionality)) {
                                    <div>
                                        <mat-checkbox [formControl]="form.controls.paid"> Afgerekend </mat-checkbox>
                                    </div>
                                }
                                @if (form.dirty) {
                                    <div class="font-italic mb-2">
                                        Sla de wijzigingen op om de definitieve afrekenstaat te zien.
                                    </div>
                                }
                                @if (print) {
                                    <div class="d-flex mb-3">
                                        <div>
                                            <b
                                                ><u>Afrekenstaat vkm {{ form.controls.afas_project_id.value }}</u></b
                                            >
                                            <div class="mt-3">
                                                <table>
                                                    <tr>
                                                        <th>Projectnummer</th>
                                                        <td>
                                                            {{ form.controls.afas_project_id.value }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Locatie</th>
                                                        <td>
                                                            {{ form.controls.location.value }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Opdrachtgever</th>
                                                        <td>
                                                            {{ form.controls.contractor.value }}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-end flex-fill">
                                            <img src="/assets/clean-logo.svg" height="125" />
                                        </div>
                                    </div>
                                }
                                <table class="table table-center">
                                    <tr>
                                        <th>Materieel</th>
                                        <th>Aanvang</th>
                                        <th>Einde</th>
                                        <th>Dagen</th>
                                        <th>Geleverd</th>
                                        <th>Huurdagen</th>
                                        <th>Tarief</th>
                                        <th>Kosten</th>
                                        <th>Kwijt</th>
                                        <th>Tarief</th>
                                        <th>Kosten</th>
                                    </tr>
                                    @for (calc of objectCalculations; track calc) {
                                        <tr>
                                            <td>
                                                {{ entitiesMap.get(calc.entity_id)?.name }}
                                            </td>
                                            <td>
                                                {{ calc.date_placed | date: 'dd-MM-yyyy' }}
                                            </td>
                                            <td>
                                                {{ calc.date_removed | date: 'dd-MM-yyyy' }}
                                            </td>
                                            <td>
                                                {{ calc.days }}
                                            </td>
                                            <td>
                                                {{ calc.count_placed }}
                                            </td>
                                            <td>
                                                {{ calc.total_days }}
                                            </td>
                                            <td class="text-right">
                                                {{ calc.price_unit | currency: 'EUR' }}
                                            </td>
                                            <td class="text-right">
                                                {{ calc.price_unit_total | currency: 'EUR' }}
                                            </td>
                                            <td
                                                [matTooltipDisabled]="
                                                    calc.count_placed == calc.count_removed + calc.count_lost
                                                "
                                                [class.error-background]="
                                                    calc.count_placed != calc.count_removed + calc.count_lost
                                                "
                                                matTooltip="Het aantal opgehaald ({{ calc.count_removed }}) + kwijt ({{
                                                    calc.count_lost
                                                }}) is niet gelijk aan het aantal items geplaatst ({{
                                                    calc.count_placed
                                                }})">
                                                @if (calc.count_placed != calc.count_removed + calc.count_lost) {
                                                    {{ calc.count_placed - calc.count_removed }} ?
                                                }
                                                @if (calc.count_placed == calc.count_removed + calc.count_lost) {
                                                    {{ calc.count_lost }}
                                                }
                                            </td>
                                            <td class="text-right">
                                                @if (calc.count_lost) {
                                                    {{ calc.price | currency: 'EUR' }}
                                                }
                                            </td>
                                            <td class="text-right">
                                                @if (calc.count_lost) {
                                                    {{ calc.price_total | currency: 'EUR' }}
                                                }
                                            </td>
                                        </tr>
                                    }
                                </table>
                                <div class="row">
                                    <div class="col">
                                        <table class="table table-center">
                                            <tr>
                                                <th>Voorbereiding en uitvoering</th>
                                                <th>Aantal</th>
                                                <th>Tarief</th>
                                                <th>Kosten</th>
                                            </tr>
                                            @for (calc of materialCalculations; track calc) {
                                                <tr>
                                                    <td>
                                                        {{ entitiesMap.get(calc.entity_id)?.name }}
                                                    </td>
                                                    <td>
                                                        {{ calc.count_placed }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ calc.price_unit | currency: 'EUR' }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ calc.price_unit_total | currency: 'EUR' }}
                                                    </td>
                                                </tr>
                                            }
                                        </table>
                                    </div>
                                    <div class="col">
                                        <table class="table">
                                            <tr>
                                                <th>Afrekenstaat</th>
                                                <th>Kosten</th>
                                            </tr>
                                            @for (calc of totalPrices; track calc) {
                                                <tr>
                                                    <td>
                                                        {{ calc.settle_group }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ calc.price | currency: 'EUR' }}
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <b>Totaal</b>
                                                </td>
                                                <td class="text-right">
                                                    <b>{{ totalPrice | currency: 'EUR' }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    }
                </mat-tab-group>
                <mat-menu #menu="matMenu">
                    <button (click)="addWorkorder('MWO')" mat-menu-item>Monteren</button>
                    <button (click)="addWorkorder('DWO')" mat-menu-item>Demonteren</button>
                </mat-menu>
            </div>
        }
    </div>
}

@if (!print) {
    <div class="button-wrapper">
        <div class="container-xl">
            @if (form) {
                <div class="buttons">
                    <button mat-raised-button color="accent" routerLink="/{{ backTo }}">Naar overzicht</button>
                    @if (Functionalities.VkmWorkorderExecution | hasFunctionality) {
                        <button [disabled]="!form.dirty || saving" (click)="save()" mat-raised-button color="primary">
                            {{
                                saved
                                    ? 'Wijzigingen opgeslagen'
                                    : form.dirty
                                      ? 'Openstaande wijzigingen opslaan'
                                      : 'Er zijn geen wijzigingen'
                            }}
                            @if (saving) {
                                <i class="fas fa-spinner fa-spin"></i>
                            }
                        </button>
                    }
                </div>
            }
        </div>
    </div>
}
